import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  standalone: false,
  selector: "app-wrapper",
  templateUrl: "./wrapper.component.html"
})
export class WrapperComponent {

  constructor(private router: Router) {
    // //console.log(this.router.url);
    if(this.router.url == "/"){
      this.router.navigate(["home"]);
    }else{
      this.router.navigate([this.router.url]);
    }
  }

}
